(function () {
    'use strict';

    angular
        .module('franchiser.services')
        .service('BankService', BankService)

    /** @ngInject */
    function BankService(HttpService) {
        const BankService = {
            getAll: getAll
        }

        return BankService;

        function getAll() {
            return HttpService.get('/banks/all');
        }
    }
}());